import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useCourseState, ProvisionCourseStep } from '../../context/CourseContext';
import { indexOf } from 'lodash';
import { getStepperStyles } from './styles';

function getSteps() {
  return [
    ProvisionCourseStep.Access,
    ProvisionCourseStep.Delivery,
    ProvisionCourseStep.Provision,
  ]
}

export default function ProvisionCoursesStepper() {
  const theme = useTheme();
  const styles = getStepperStyles(theme);
  const { activeStep } = useCourseState();

  return (
    <Box sx={styles.root}>
      <Stepper activeStep={indexOf(getSteps(), activeStep)} alternativeLabel>
        {getSteps().map((step, index) => (
          <Step key={index}>
            <StepLabel>{step}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
